import { uaParser as ua } from '@encarpkg/shared';

const encarURL = process.env.REACT_APP_ENCAR_MOBILE;
const encarPcURL = process.env.REACT_APP_ENCAR_PC;

function encarUrlBuilder(navigator) {
	let pcPathname = '';
	let mobilePathname = '';

	const build = () => {
		const encarPC = encarPcURL || 'https://new.encar.com';
		const encarMobile = encarURL || 'https://mnew.encar.com';

		return ua(navigator).isMobile || ua(navigator).isApp ? `${encarMobile}${mobilePathname}` : `${encarPC}${pcPathname}`;
	};

	return {
		pc(pathname) {
			pcPathname = pathname;
			return mobilePathname ? build() : this;
		},
		mobile(pathname) {
			mobilePathname = pathname;
			return pcPathname ? build() : this;
		},
	};
}

export default encarUrlBuilder;
